<div class="dp-host"
  [class.dp-host--open]="isOpen"
  [class.dp-host--disabled]="disabled"
  [class.dp-host--range]="mode === 'range'">

  <!-- Label -->
  <label class="dp-label" *ngIf="label">{{ label }}</label>

  <!-- ── Input trigger ─────────────────────────────────────────────────── -->
  <div class="dp-input-wrap" (click)="toggleCalendar()">

    <span class="dp-input-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
        <line x1="16" y1="2" x2="16" y2="6"></line>
        <line x1="8" y1="2" x2="8" y2="6"></line>
        <line x1="3" y1="10" x2="21" y2="10"></line>
      </svg>
    </span>

    <!-- Single mode display -->
    <ng-container *ngIf="mode === 'single'">
      <span class="dp-input-value" [class.dp-input-value--placeholder]="!displayValue">
        {{ displayValue || placeholder }}
      </span>
    </ng-container>

    <!-- Range mode display -->
    <ng-container *ngIf="mode === 'range'">
      <div class="dp-range-display">
        <span class="dp-range-pill" [class.dp-range-pill--active]="!!rangeStart">
          <span class="dp-range-pill__val">
            {{ rangeStart ? (rangeStart | date: 'dd MMM yyyy') : 'Start date' }}
          </span>
        </span>
        <span class="dp-range-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg>
        </span>
        <span class="dp-range-pill" [class.dp-range-pill--active]="!!rangeEnd">
          <span class="dp-range-pill__val">
            {{ rangeEnd ? (rangeEnd | date: 'dd MMM yyyy') : 'End date' }}
          </span>
        </span>
      </div>
    </ng-container>

    <span class="dp-input-actions">
      <span class="dp-clear-btn" *ngIf="hasValue" (click)="clearDate($event)" title="Clear">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </span>
      <span class="dp-chevron" [class.dp-chevron--up]="isOpen">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </span>
    </span>
  </div>

  <!-- Range hint -->
  <div class="dp-range-hint" *ngIf="mode === 'range' && isOpen">
    <span class="dp-range-hint__dot"
      [class.dp-range-hint__dot--done]="rangeStart && !selectingEnd"></span>
    <span *ngIf="!selectingEnd || !rangeStart">Click to set <strong>start</strong> date</span>
    <span *ngIf="selectingEnd && rangeStart">Now pick the <strong>end</strong> date</span>
  </div>

  <!-- ── Calendar dropdown ──────────────────────────────────────────────── -->
  <div class="dp-dropdown" *ngIf="isOpen">

    <!-- ── DAYS VIEW ── -->
    <ng-container *ngIf="viewMode === 'days'">
      <div class="dp-nav">
        <button class="dp-nav-btn" (click)="prevMonth()" type="button">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        </button>
        <div class="dp-nav-title">
          <button class="dp-nav-label" type="button" (click)="setViewMode('months')">
            {{ MONTH_NAMES[viewMonth] }}
          </button>
          <button class="dp-nav-label" type="button" (click)="setViewMode('years')">
            {{ viewYear }}
          </button>
        </div>
        <button class="dp-nav-btn" (click)="nextMonth()" type="button">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </button>
      </div>

      <!-- Weekday headers -->
      <div class="dp-grid dp-weekdays">
        <span *ngFor="let d of WEEKDAYS">{{ d }}</span>
      </div>

      <!-- Day cells -->
      <div class="dp-grid dp-days">
        <button
          *ngFor="let day of calendarDays"
          type="button"
          class="dp-day"
          [class.dp-day--other]="day.otherMonth"
          [class.dp-day--today]="isToday(day.date)"
          [class.dp-day--selected]="isSelected(day.date)"
          [class.dp-day--range-start]="mode === 'range' && isRangeStart(day.date)"
          [class.dp-day--range-end]="mode === 'range' && isRangeEnd(day.date)"
          [class.dp-day--in-range]="isInRange(day.date)"
          [class.dp-day--hover-edge]="isHoverEdge(day.date)"
          [class.dp-day--disabled]="isDateDisabled(day.date)"
          (click)="selectDay(day)"
          (mouseenter)="onDayHover(day.date)"
          (mouseleave)="onDayLeave()">
          {{ day.date.getDate() }}
        </button>
      </div>

      <!-- Footer -->
      <div class="dp-footer">
        <button class="dp-today-btn" type="button"
          (click)="selectDay({ date: todayDate, otherMonth: false })">
          Today
        </button>
        <button class="dp-today-btn dp-today-btn--ghost" *ngIf="mode === 'range' && selectingEnd"
          type="button" (click)="rangeStart = null; selectingEnd = false">
          Reset
        </button>
      </div>
    </ng-container>

    <!-- ── MONTHS VIEW ── -->
    <ng-container *ngIf="viewMode === 'months'">
      <div class="dp-nav">
        <button class="dp-nav-btn" (click)="prevYear()" type="button">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        </button>
        <button class="dp-nav-label" type="button" (click)="setViewMode('years')">{{ viewYear }}</button>
        <button class="dp-nav-btn" (click)="nextYear()" type="button">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </button>
      </div>
      <div class="dp-month-grid">
        <button
          *ngFor="let name of SHORT_MONTH_NAMES; let i = index"
          class="dp-month-cell"
          type="button"
          [class.dp-month-cell--active]="i === viewMonth"
          (click)="selectMonth(i)">
          {{ name }}
        </button>
      </div>
    </ng-container>

    <!-- ── YEARS VIEW ── -->
    <ng-container *ngIf="viewMode === 'years'">
      <div class="dp-nav">
        <button class="dp-nav-btn" (click)="prevYearPage()" type="button">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        </button>
        <span class="dp-nav-label dp-nav-label--static">
          {{ yearRange[0] }} – {{ yearRange[yearRange.length - 1] }}
        </span>
        <button class="dp-nav-btn" (click)="nextYearPage()" type="button">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </button>
      </div>
      <div class="dp-year-grid">
        <button
          *ngFor="let yr of yearRange"
          class="dp-year-cell"
          type="button"
          [class.dp-year-cell--active]="yr === viewYear"
          (click)="selectYear(yr)">
          {{ yr }}
        </button>
      </div>
    </ng-container>

  </div>
</div>
